import { useState } from 'react'
import { Stack } from '@chakra-ui/react'

import { CustomFormValidateField } from 'components/tools/CustomForm/types'
import { FormItem, MaskedInput } from 'components'
import { brazilianTelephoneMask } from 'utils/masks'
import { validatePhone } from 'utils/validation/validators'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import useSetDefaultValueOnNotArrayData from '../../hooks/useSetDefaultValueOnNotArrayData'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'

export default function DefaultValuePhone({ formMethods, question }: DefaultValueCommonProps) {
  const [isFieldValid, setIsFieldValid] = useState<CustomFormValidateField>({
    isValid: true,
    message: '',
  })

  const handleValidatePhone = (phone: string): boolean => {
    let initialValue = { isValid: true, message: '' }

    if (phone && !validatePhone(phone)) {
      initialValue = { isValid: false, message: 'Telefone está errado' }
    }

    setIsFieldValid(initialValue)
    return initialValue.isValid
  }

  useUnregisterDefaultValueField({ formMethods })

  useSetDefaultValueOnNotArrayData({ formMethods, question })

  return (
    <Stack>
      <FormItem label="Valor inicial">
        <MaskedInput
          mask={brazilianTelephoneMask}
          {...formMethods.register('default_value', {
            validate: handleValidatePhone,
          })}
        />
      </FormItem>

      <CustomFormFieldErrorMessage {...isFieldValid} />
    </Stack>
  )
}
